module.exports = __webpack_public_path__ + "img/fankui.262aabe7.png";